import axiosInstance from "../API/axiosInstance";
import { API_ENDPOINTS } from "../API/endpoints";

export const getAccessToken = () => {
  return localStorage.getItem("authToken");
};

export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken");
};

export const logout = () => {
  localStorage.clear();
  window.location.href = "/";
};

export const refreshToken = async () => {
  try {
    const refreshToken = getRefreshToken();
    if (!refreshToken) {
      throw new Error("No refresh token available");
    }

    const response = await axiosInstance.post(API_ENDPOINTS.refreshToken, {
      refreshToken,
    });

    // If the response contains a new authToken object
    if (response.data.authToken) {
      const { accessToken, refreshToken: newRefreshToken } =
        response.data.authToken;
      localStorage.setItem("authToken", accessToken);
      localStorage.setItem("refreshToken", newRefreshToken);
      return accessToken;
    }

    return null;
  } catch (error) {
    console.error("Failed to refresh token:", error);
    return null;
  }
};
